// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./image/ProductPlaceholder.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
}

* {
    margin: 0%;
    padding: 0%;
    font-family: acumin-pro, sans-serif;
}

.icon > img {
    object-fit: none;
}

.radio_button_permission {
    display: none !important;
}


/* k */
.header_icons_mt .css-jfo9gg {
    padding: 0 !important;
}

.drawer_menu_mt {
    transform: translateX(0) translateY(70px) translateZ(0px) !important;
    right: 2.67% !important;
    width: 98% !important;
    max-width: 98% !important;
    padding-bottom: 70px;
}

li.list_items_menu_mobile {
    list-style: none;
    border-left: 10px solid #592C82;
    padding: 25px 30px;
    background: #F2F2F2;
    border-bottom: 1px solid #C4C4C4;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

ul.mobile_menu_list {
    margin: 0 !important;
}

.drawer_menu_mt .css-qwjbfp {
    background: #F2F2F2 !important;
}

.drawer_body_content_mt {
    padding: 0 !important;
    background: #F2F2F2;
}

.list_button_menu_mobile {
    list-style: none;
    padding: 25px 30px;
    background: #F2F2F2;
    border-bottom: 1px solid #C4C4C4;
    border-left: 10px solid transparent;
}

.drawermenu_close_button_mt {
    position: relative !important;
    width: 100% !important;
    text-align: left;
    justify-content: flex-start !important;
    top: unset !important;
    right: unset !important;
    height: auto !important;
}

.drawermenu_close_button_mt_text {
    font-family: acumin-pro, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    letter-spacing: 1.25px;
}

.drawermenu_close_button_mt_text svg {
    Width: 17px;
    height: 12px;
    color: #000000;
    font-weight: 700;
    margin-right: 7px;
}

.drawermenu_close_button_mt:focus, .drawermenu_close_button_mt[data-focus] {
    box-shadow: none !important;
}

.drawermenu_close_button_mt:active, .drawermenu_close_button_mt[data-active] {
    background: transparent !important;
}

.drawermenu_close_button_mt, .drawermenu_close_button_mt[data-hover] {
    background: transparent !important;
}

.drawermenu_item_mt {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.rectangle_63 {
    margin: auto;
}

.layer_box_icon {
    width: 50%;
    padding-bottom: 50px;
}

.rectangle_63_layer {
    width: 100%;
    opacity: 0.5;
    background: white;
    position: absolute;
    bottom: 0;
    top: 0;
}

.linkHover:hover {
    color: white;
}


.rectangle_63_layer svg {
    transform: translate(-50%, -50%);
    width: 100%;
    top: 50%;
    left: 50%;
    font-size: 70px;
    position: absolute;
}

/*About page*/

.about_container {
    max-width: 1230px;
    margin: auto;
}

.brands_image img, .bg_image img {
    width: 100%;
}

.about_2_box {
    width: 50%;
    padding: 20px;
}

.about_slider {
    color: #FFFF;
    top: 100px;
    left: -40px;
    width: 700px !important;
    margin: auto;
}

.slider_box {
    width: 500px !important;
    padding: 15px 0;
}


.about_slider .slick-prev, .about_slider .slick-next {
    top: 140px;
    z-index: 111;
}

.about_slider .slick-prev::before, .slick-next::before {
    font-size: 50px;
    color: #FFFFFF;
    opacity: 1;
}

.team {
    display: flex;
    flex-wrap: wrap;
    width: 100% !important;
}

.team .teammember {
    width: 250px;
    margin: 40px auto;
    height: 250px;
    border-radius: 50%;
    background-color: #4D4D4D;
}

.team .teammember img {
    width: 100%;
}

/*About page*/


.scrollY {
    scrollbar-width: none;
}

.scrollY::-webkit-scrollbar {
    display: none;
}

.drawermenu_item_mt svg {

    Width: 17px;
    height: 17px;
    color: #000000;
    font-weight: 700;
}

span.main_menu_showdrawer_mt {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #000000;
}

.drawer_body_content_mt {
    padding: 0 !important;
    background: #F2F2F2;
    overflow-y: auto !important;
    height: 100%;
    transition: left .4s ease;
}


.drawermenu_close_button_mt_text {
    display: flex;
    align-items: center;
}

.main_header a {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    font-family: acumin-pro, sans-serif;
    font-style: normal;
    font-weight: 400;
    color: #1A1A1A;
    padding: 15px 15px 15px 0;
}

.main_header button {
    padding: 0;
    border: none !important;
}

.telephone_number_a {
    font-weight: 700 !important
}

.css-141z5hc {
    padding: 0px;
}

.footer_border {
    border-bottom: 1px solid #4D4D4D;
}

.footer_icons {
    list-style-type: none !important;
}

.footer_icons li {
    float: left;
    margin-left: 15px;
    width: 24px;
    height: 24px;
}

.footer_icons li svg {
    width: 100%;
    height: 100%;
}


.context_flex {
    display: flex;
}

.mobile_logo img {
    max-width: 170px;
    width: auto;
}

.footer_divider {
    height: 170px !important;
    border-color: #4D4D4D !important;
    margin-left: 0px;
    margin-right: 80px;
}

.footer_menu_heading {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #000;
}

.menu_footer_mt {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #000000;
}

.footer_main_menu {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #000000;
}

.about_main {
    padding: 100px 0;
}

.footer_social_heading {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0.5px !important;
    color: #000000;
}

.footer_bottom_section {
    background-color: #4D4D4D;
    padding: 9px 25px;
}

.footer_bottom_section_content {
    color: #FFF;
    justify-content: space-between;
    letter-spacing: 0.25px;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
}

.footer_bottom_icon {
    display: inline-block;
}

.slick-dots {
    position: absolute;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    z-index: 1;
}


.search_input_home::-moz-placeholder, .search_input_home::placeholder {
    color: #000;
    letter-spacing: 0.5px;
    font-family: acumin-pro, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px
}

.css-10gf8jm, .css-sntwt5 {
    max-width: 100% !important;
}

.menu_item {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    padding-left: 0% !important;
}

.css-1ltezim:focus, .css-1ltezim[data-focus] {
    z-index: 1;
    box-shadow: none !important;
    background-color: none !important;
}

.css-1ltezim:active, .css-1ltezim[data-active] {
    background: none !important;
}

.main_menu_mt_home a {
    letter-spacing: 1.25px;
    text-transform: uppercase;
    font-family: acumin-pro, sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
}

.chakra-menu__menuitem {
    color: #000000;
}

.footer_menu_heading {
    letter-spacing: 0.5px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    font-family: acumin-pro, sans-serif;
}

.menu_footer_mt {
    font-family: acumin-pro, sans-serif;
}

ul.footer_icons {
    display: flex;
    width: 100%;
    max-width: 100%;
    justify-content: flex-end;
    position: relative;
    z-index: 1;
}

.footer_icon {
    width: 27% !important;
    padding: 10px 0 !important;
    margin-left: 0 !important;
}

.footer_headings {
    font-weight: 300;
}


.slick-dots li button:before {
    font-size: 20px !important;
    opacity: 1 !important;
    color: #FFFFFF !important;

}

.slick-dots li.slick-active button:before {
    color: #EC7700 !important;
}

.left_contact {
    width: 50%;
    padding: 50px;
}

.right_contact {
    width: 50%;
    padding: 50px;
    background-color: #F6F6F6;
}

.input_type {
    background-color: white !important;
}

.form_controll {
    padding: 10px;
}

.content_box {
    width: 68%;
    line-height: 24px;
}

.left_contact_child {
    padding: 10px 0;
}

.download-broucher > td:first-child {
    width: 100%;
}

@media (max-width: 900px) {

    .header_respo {
        width: 80%;
        margin: auto;
    }

    .slideBox {
        font-size: 30px !important;
    }

    .slick-next {
        right: 30px !important;
    }

    .team .teammember {
        width: 250px;
        margin: 20px auto;
        height: 250px;
        border-radius: 50%;
    }

    .about_slider {
        color: #FFFF;
        top: 50px;
        left: 20px;
        width: 90% !important;
        text-align: center;
        padding: 0 25px;
        margin: 0 10px;
    }

    .slider_box {
        width: 100% !important;
        padding: 15px 0;
    }

    .context_flex {
        display: block;
    }

    .left_contact, .right_contact {
        width: 100%;
        padding: 10px;
    }
}


.svg_icon_branch {
    width: 25px;
    height: 25px;
    margin-right: 15px;
    display: inline-block;
    vertical-align: middle;
}

.new_branch_tab {
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
}

.company_page_container {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.drillcut_companies {
    padding-left: 60px;
}

.drillcut_companies {
    padding-left: 60px;
    max-width: 1000px;
}

.drillcut_company_new_add {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 18px;
}

.drillcut_table_branch th {
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #000;
}

.company_title_heading {
    padding-left: 60px;
    padding-top: 15px;
    padding-bottom: 15px;
}

.company_title_heading .pages_project_bar_heading {
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
    color: #1A1A1A;
    text-transform: capitalize;
    text-align: left;
}

.mini_dark_grey_color {
    background: #F6F6F6;
}

.branch_information_tab {
    background: #E9EAEB;
}

.branchinformationheading {
    padding: 15px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 16px !important;
    text-align: left;
}

.company_information_form {
    padding: 15px;
}

.company_detail_form_grid {
    gap: 20px;
    margin-bottom: 20px;
}

.company_detail_form_grid input, .company_detail_form_grid select {
    background: #FFFFFF;
    border-radius: 5px;
}

.labels_company_data {
    letter-spacing: 0.15px;
    text-transform: uppercase;
    font-weight: 400 !important;
    font-size: 12px !important;
    line-height: 16px !important;
}

.branchLinkColor {
    color: #F58220;
    letter-spacing: 0.25px;
    font-size: 14px;
    line-height: 20px;
    text-transform: capitalize;
    font-weight: 600;
}

@media (max-width: 769px) {

    .about_contain {
        padding: 30px;
    }

    .company_title_heading {
        padding: 20px !important;
    }

    .drillcut_companies {
        padding-left: 20px;
        padding-right: 20px;
    }

    .about_2_box {
        width: 100%;
    }

    .flexDirection {
        flex-direction: column;
    }

    .drillcut_company_mobile_view {
        display: flex;
        padding: 20px;
        margin-bottom: 15px;
    }

    .branchInformationHeading {
        margin-right: 35px;
        text-align: left;
    }

    .branchInformationContent {
        text-align: left;
    }

    .branchInformationContent a {
        letter-spacing: 0.25px;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
    }

    .orderBy {
        order: 1;
    }

    .about_2_box img {
        width: 100%;
    }

    .content_box {
        width: 100%
    }

    .layer_box_icon {
        width: 90%;
        padding: 50px 0;
    }

    .about_contain {
        padding: 50px !important;
    }

    .header_respo {
        width: 100%;
        padding: 10px 0;
        font-size: 30px;
    }

    .about-box {
        height: auto;
        padding: 40px 50px;
    }

    .slideBox {
        font-size: 20px !important;
    }

    .slick-next {
        right: 10px !important;
    }

    .team .teammember {
        width: 250;
        margin: 20px auto;
        height: 250;
        border-radius: 50%;
    }

    .about_slider {
        color: #FFFF;
        top: 50px;
        left: 15px;
        width: 90% !important;
        text-align: center;
        padding: 0 25px;
        margin: 0 10px;
    }


    .split_icon_desktop {
        display: none;
    }

    .footer_bottom_section {
        padding-top: 25px !important;
        padding-bottom: 25px !important;
    }

    .footer_bottom_section_content, .footer_headings {
        display: flex;
        flex-direction: column;
    }

    p.footer_logo {
        margin-top: 15px;
    }

    ul.footer_icons {
        justify-content: flex-start;
    }

    .footer_menu-content {
        justify-content: space-between;
    }

    .menu_icon_mobile_view {
        justify-content: flex-end !important;
    }

    .menu_icon_mobile_view img {
        width: 10px;
    }
}


@media (max-width: 365px) {
    .footer_logo_main {
        width: 100%;
    }

    .footer_logo_main_logo {
        width: 190px;
    }

    .footer_job_done_logo {
        width: 75px;
    }

    .team .teammember {
        width: 120px !important;
        margin: 20px auto;
        height: 120px !important;
        border-radius: 50%;
    }
}


@media (max-width: 515px) {

    .layer_box_icon {
        width: 100%;
        padding: 50px 0;
    }

    .team .teammember {
        width: 170px;
        margin: 20px auto;
        height: 170px;
        border-radius: 50%;
    }

    .content_box {
        width: 100%;
    }

    .about_container {
        padding: 20px;
    }

    .about-box {
        height: auto;
        padding: 10px 0;
    }

    .about_contain {
        padding: 0 !important;
    }

    .brands_image2 img {
        width: 50%;
        height: auto;
    }

    .about_main {
        padding: 0;
    }

    .about_2_box {
        width: 100%;
    }

    .slideBox {
        font-size: 18px !important;
    }

    .slick-next {
        right: 10px !important;
    }

    .about_slider {
        color: #FFFF;
        top: 50px;
        left: 0;
        width: 94% !important;
        text-align: left;
        padding: 0 25px;
        margin: 0 10px;
    }

    .slider_box {
        width: 100% !important;
        padding: 15px 0;
    }

    .about_slider .slick-prev::before, .slick-next::before {
        font-size: 35px;
        color: #FFFFFF;
        opacity: 1;
    }

    .header_respo {
        padding: 10px 0;
        font-size: 25px;
    }

}


.full_width_container {
    max-width: 100% !important;
    padding: 0 !important;
    position: relative !important;
}

.component {
    padding-top: 20px;
}

.main_menu_items_mt {
    font-family: acumin-pro, sans-serif;
    font-weight: 700 !important;
    letter-spacing: 1.25px;
    line-height: 16px;
    text-transform: uppercase;
    color: #000;
    font-size: 14px;
}

.main_menu_mt_home {
    position: relative;
}

.truck_icon {
    transform: scaleX(-1);
    display: inline-block;
    font-size: 20px;
    vertical-align: bottom;
}

.menu_open_mt {
    position: absolute;
    width: 365px;
    left: -10px;
    top: 46px;
    background-color: #F2F2F2 !important;
    border: none;
    border-radius: 0 !important;
    z-index: 9 !important;
}

.Default_height_set {
    overflow: hidden;
    overflow-y: auto;
    max-height: calc(95vh - 164px);
    height: 88vh;
    width: 100%;
}

div[data-popper-placement="bottom-start"] {
    z-index: 999;
}

.main_class_menu_mt {
    background-color: white;
}

.activetag {
    background-color: blue;
}

.chiled_open_mt {
    position: absolute;
    width: 365px;
    left: 360px;
    top: 0;
    background-color: #F2F2F2 !important;
    border: none;
    border-radius: 0 !important;
}

.chiled_open_mt-2 {
    position: absolute;
    width: 365px;
    left: 360px;
    top: 0;
    background-color: #F2F2F2 !important;
    border: none;
    border-radius: 0 !important;
}

.menu_open_mt button, .chiled_header, .dropdown_menu_list, .menu_open_mt > a {
    padding: 20px 30px;
    min-height: 58px;
    border-bottom: 1px solid #C4C4C4;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
    z-index: 999;
}

.dropdown_menu_list {
    display: flex;
}

.active, .menu_open_mt button:hover, .dropdown_menu_list:hover, .menu_open_mt > a:hover {
    background-color: #592C82;
    color: #FFF !important;
}

.log_vertical {
    align-self: center !important;
}

.layer {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    left: 0;
    height: 900px;
    top: 55px;
    z-index: 1;
}

.layer2 {
    display: none;
}

.main_menu_mt_home .css-r6z5ec {
    transform: none !important;
}

.main_menu_items_mt span {
    display: flex;
    justify-self: center;
    align-items: center;
}

.button_mt_about {
    width: 130px;
    display: block;
    text-align: center;
    margin: 10px 0;
}

.slideBox {
    line-height: 36px;
    font-size: 34px;
}

.header_icons_mt .css-jfo9gg {
    padding: 0 !important;
}

.drawer_menu_mt {
    transform: translateX(0) translateY(70px) translateZ(0px) !important;
    right: 2.67% !important;
    width: 98% !important;
    max-width: 98% !important;
}

li.list_items_menu_mobile {
    list-style: none;
    border-left: 10px solid #592C82;
    padding: 25px 30px;
    background: #F2F2F2;
    border-bottom: 1px solid #C4C4C4;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
}

ul.mobile_menu_list {
    margin: 0 !important;
}

.drawer_menu_mt .css-qwjbfp {
    background: #F2F2F2 !important;
}

.drawer_body_content_mt {
    padding: 0 !important;
    background: #F2F2F2;
}

.list_button_menu_mobile {
    list-style: none;
    padding: 25px 30px;
    background: #F2F2F2;
    border-bottom: 1px solid #C4C4C4;
    border-left: 10px solid transparent;
}

.drawermenu_close_button_mt {
    position: relative !important;
    width: 100% !important;
    text-align: left;
    justify-content: flex-start !important;
    top: unset !important;
    right: unset !important;
    height: auto !important;
}

.drawermenu_close_button_mt_text {
    font-family: acumin-pro, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
}

.drawermenu_close_button_mt_text svg {
    Width: 17px;
    height: 18.55px;
    color: #000000;
    font-weight: 700;
    margin-right: 7px;
}

.drawermenu_close_button_mt:focus, .drawermenu_close_button_mt[data-focus] {
    box-shadow: none !important;
}

.drawermenu_close_button_mt:active, .drawermenu_close_button_mt[data-active] {
    background: transparent !important;
}

.drawermenu_close_button_mt, .drawermenu_close_button_mt[data-hover] {
    background: transparent !important;
}

.drawermenu_item_mt {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.drawermenu_item_mt svg {

    Width: 17px;
    height: 17px;
    color: #000000;
    font-weight: 700;
}

span.main_menu_showdrawer_mt {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #000000;
}

.an_testimonial_text_title_box {
    max-height: 500px !important;
}

.an_comment_box {
    height: auto !important;
}

.chat-now-button {
    width: 120px;
    height: 40px;
    position: fixed;
    bottom: 30px;
    left: 30px;
    z-index: 120;
}

.bg_strip_btn_save .chakra-text,
.bd_crum .chakra-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #EC7700;
    cursor: pointer;
    transition: all 0.3s ease-in;
}

.about_announcment_container.center {
    text-align: center;
}

body .chakra-container {
    max-width: 100%;
}

.know-us-image-top {
    display: none;
}

.root-certify .know-us-image-top.certify,
.root-supply .know-us-image-top.supply,
.root-customise .know-us-image-top.customise,
.root-train .know-us-image-top.train,
.root-plan .know-us-image-top.plan,
.root-design .know-us-image-top.design,
.root-consult .know-us-image-top.consult,
.root-review .know-us-image-top.review,
.root-360 .know-us-image-top[data-class="360"] {
    display: block;
}

.cone-aa .imgclick {
    opacity: 0.2;
}

.root-certify .cone-aa .certify,
.root-supply .cone-aa .supply,
.root-customise .cone-aa .customise,
.root-train .cone-aa .train,
.root-plan .cone-aa .plan,
.root-design .cone-aa .design,
.root-consult .cone-aa .consult,
.root-review .cone-aa .review,
.root-360 .cone-aa .imgclick {
    opacity: 1;
}

.tabs-menu .menuclick {
    cursor: pointer;
}

.root-certify .tabs-menu .menuclick.certify,
.root-supply .tabs-menu .menuclick.supply,
.root-customise .tabs-menu .menuclick.customise,
.root-train .tabs-menu .menuclick.train,
.root-plan .tabs-menu .menuclick.plan,
.root-design .tabs-menu .menuclick.design,
.root-consult .tabs-menu .menuclick.consult,
.root-review .tabs-menu .menuclick.review,
.root-360 .tabs-menu .menuclick[data-class="360"] {
    background-color: #592C82 !important;
}

.root-certify .tabs-menu .menuclick.certify a,
.root-supply .tabs-menu .menuclick.supply a,
.root-customise .tabs-menu .menuclick.customise a,
.root-train .tabs-menu .menuclick.train a,
.root-plan .tabs-menu .menuclick.plan a,
.root-design .tabs-menu .menuclick.design a,
.root-consult .tabs-menu .menuclick.consult a,
.root-review .tabs-menu .menuclick.review a,
.root-360 .tabs-menu .menuclick[data-class="360"] a {
    color: #fff;
}

.level-2 td.blck-srtdt.css-xumdn4 spancustom::before,
.level-1 td.blck-srtdt.css-xumdn4 spancustom::before {
    content: '';
    border-left: 2px solid #cccccc;
    text-indent: 20px;
    position: absolute;
    height: 100%;
    top: 0;
}

.level-2 td.blck-srtdt.css-xumdn4 spancustom::before {
    margin-left: -46px;
}

.level-1 td.blck-srtdt.css-xumdn4 spancustom::before {
    margin-left: -21px;
}

tr.level-1.css-4g6ai3,
tr.level-2.css-4g6ai3 {
    position: relative;
}


.level-2 td.blck-srtdt.css-xumdn4 spancustom::after {
    content: '';
    border-top: 2px solid #cccccc;
    position: absolute;
    width: 35px;
    left: 63px;
    top: 50%;
}

.level-1 td.blck-srtdt.css-xumdn4 spancustom::after {
    content: '';
    border-top: 2px solid #cccccc;
    position: absolute;
    width: 10px;
    left: 63px;
    top: 50%;
}

.background_image_loading {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: contain;
}

.flex-box {
    display: flex;
}

.align-flex-center {
    align-items: center;
}

.user-to-drop {
    border: 1px solid #ec7700;
}

.text-uppercase {
    text-transform: capitalize;
}

.chakra-popover__popper.css-1qq679y {
    z-index: 1500 !important;
}

#content-box {
    align-self: flex-start;
}

#brand-text {
    padding-top: 20px !important;
    height: 130px !important;
}

.hs-shadow-container.active {
    background-color: transparent;
}

@media screen and ( max-width: 930px) {
    #brand-text {
        padding-top: 20px !important;
        height: auto !important;
    }
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Blur effect */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .loader {
    width: 50px;
    height: 50px;
    border: 5px solid #553c9a;
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA,MAAM;AACN;IACI,qBAAqB;AACzB;;AAEA;IACI,oEAAoE;IACpE,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,gCAAgC;IAChC,WAAW;IACX,QAAQ;IACR,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA,aAAa;;AAEb;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA,aAAa;;;AAGb;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;;AAGA;IACI,WAAW;IACX,qBAAqB;IACrB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf,cAAc;IAClB;;;IAGA;QACI,aAAa;IACjB;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,wBAAwB;QACxB,kBAAkB;IACtB;AACJ;;;AAGA;;IAEI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,SAAS;QACT,OAAO;QACP,qBAAqB;QACrB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,UAAU;IACd;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;AAEJ;;;AAGA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,oCAAoC;IACpC,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,MAAM;IACN,oCAAoC;IACpC,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,MAAM;IACN,oCAAoC;IACpC,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,OAAO;IACP,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oEAAoE;IACpE,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;;;;;IASI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;;;;IASI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;;;;;IASI,oCAAoC;AACxC;;AAEA;;;;;;;;;IASI,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,2EAAyE;IACzE,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,4BAA4B;QAC5B,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,gBAAgB;IAChD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":[".visually-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0,0,0,0);\n    border: 0;\n}\n\n* {\n    margin: 0%;\n    padding: 0%;\n    font-family: acumin-pro, sans-serif;\n}\n\n.icon > img {\n    object-fit: none;\n}\n\n.radio_button_permission {\n    display: none !important;\n}\n\n\n/* k */\n.header_icons_mt .css-jfo9gg {\n    padding: 0 !important;\n}\n\n.drawer_menu_mt {\n    transform: translateX(0) translateY(70px) translateZ(0px) !important;\n    right: 2.67% !important;\n    width: 98% !important;\n    max-width: 98% !important;\n    padding-bottom: 70px;\n}\n\nli.list_items_menu_mobile {\n    list-style: none;\n    border-left: 10px solid #592C82;\n    padding: 25px 30px;\n    background: #F2F2F2;\n    border-bottom: 1px solid #C4C4C4;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n}\n\nul.mobile_menu_list {\n    margin: 0 !important;\n}\n\n.drawer_menu_mt .css-qwjbfp {\n    background: #F2F2F2 !important;\n}\n\n.drawer_body_content_mt {\n    padding: 0 !important;\n    background: #F2F2F2;\n}\n\n.list_button_menu_mobile {\n    list-style: none;\n    padding: 25px 30px;\n    background: #F2F2F2;\n    border-bottom: 1px solid #C4C4C4;\n    border-left: 10px solid transparent;\n}\n\n.drawermenu_close_button_mt {\n    position: relative !important;\n    width: 100% !important;\n    text-align: left;\n    justify-content: flex-start !important;\n    top: unset !important;\n    right: unset !important;\n    height: auto !important;\n}\n\n.drawermenu_close_button_mt_text {\n    font-family: acumin-pro, sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    text-transform: uppercase;\n    letter-spacing: 1.25px;\n}\n\n.drawermenu_close_button_mt_text svg {\n    Width: 17px;\n    height: 12px;\n    color: #000000;\n    font-weight: 700;\n    margin-right: 7px;\n}\n\n.drawermenu_close_button_mt:focus, .drawermenu_close_button_mt[data-focus] {\n    box-shadow: none !important;\n}\n\n.drawermenu_close_button_mt:active, .drawermenu_close_button_mt[data-active] {\n    background: transparent !important;\n}\n\n.drawermenu_close_button_mt, .drawermenu_close_button_mt[data-hover] {\n    background: transparent !important;\n}\n\n.drawermenu_item_mt {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.rectangle_63 {\n    margin: auto;\n}\n\n.layer_box_icon {\n    width: 50%;\n    padding-bottom: 50px;\n}\n\n.rectangle_63_layer {\n    width: 100%;\n    opacity: 0.5;\n    background: white;\n    position: absolute;\n    bottom: 0;\n    top: 0;\n}\n\n.linkHover:hover {\n    color: white;\n}\n\n\n.rectangle_63_layer svg {\n    transform: translate(-50%, -50%);\n    width: 100%;\n    top: 50%;\n    left: 50%;\n    font-size: 70px;\n    position: absolute;\n}\n\n/*About page*/\n\n.about_container {\n    max-width: 1230px;\n    margin: auto;\n}\n\n.brands_image img, .bg_image img {\n    width: 100%;\n}\n\n.about_2_box {\n    width: 50%;\n    padding: 20px;\n}\n\n.about_slider {\n    color: #FFFF;\n    top: 100px;\n    left: -40px;\n    width: 700px !important;\n    margin: auto;\n}\n\n.slider_box {\n    width: 500px !important;\n    padding: 15px 0;\n}\n\n\n.about_slider .slick-prev, .about_slider .slick-next {\n    top: 140px;\n    z-index: 111;\n}\n\n.about_slider .slick-prev::before, .slick-next::before {\n    font-size: 50px;\n    color: #FFFFFF;\n    opacity: 1;\n}\n\n.team {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100% !important;\n}\n\n.team .teammember {\n    width: 250px;\n    margin: 40px auto;\n    height: 250px;\n    border-radius: 50%;\n    background-color: #4D4D4D;\n}\n\n.team .teammember img {\n    width: 100%;\n}\n\n/*About page*/\n\n\n.scrollY {\n    scrollbar-width: none;\n}\n\n.scrollY::-webkit-scrollbar {\n    display: none;\n}\n\n.drawermenu_item_mt svg {\n\n    Width: 17px;\n    height: 17px;\n    color: #000000;\n    font-weight: 700;\n}\n\nspan.main_menu_showdrawer_mt {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    color: #000000;\n}\n\n.drawer_body_content_mt {\n    padding: 0 !important;\n    background: #F2F2F2;\n    overflow-y: auto !important;\n    height: 100%;\n    transition: left .4s ease;\n}\n\n\n.drawermenu_close_button_mt_text {\n    display: flex;\n    align-items: center;\n}\n\n.main_header a {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.4px;\n    font-family: acumin-pro, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    color: #1A1A1A;\n    padding: 15px 15px 15px 0;\n}\n\n.main_header button {\n    padding: 0;\n    border: none !important;\n}\n\n.telephone_number_a {\n    font-weight: 700 !important\n}\n\n.css-141z5hc {\n    padding: 0px;\n}\n\n.footer_border {\n    border-bottom: 1px solid #4D4D4D;\n}\n\n.footer_icons {\n    list-style-type: none !important;\n}\n\n.footer_icons li {\n    float: left;\n    margin-left: 15px;\n    width: 24px;\n    height: 24px;\n}\n\n.footer_icons li svg {\n    width: 100%;\n    height: 100%;\n}\n\n\n.context_flex {\n    display: flex;\n}\n\n.mobile_logo img {\n    max-width: 170px;\n    width: auto;\n}\n\n.footer_divider {\n    height: 170px !important;\n    border-color: #4D4D4D !important;\n    margin-left: 0px;\n    margin-right: 80px;\n}\n\n.footer_menu_heading {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n    color: #000;\n}\n\n.menu_footer_mt {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n    color: #000000;\n}\n\n.footer_main_menu {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n    color: #000000;\n}\n\n.about_main {\n    padding: 100px 0;\n}\n\n.footer_social_heading {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    letter-spacing: 0.5px !important;\n    color: #000000;\n}\n\n.footer_bottom_section {\n    background-color: #4D4D4D;\n    padding: 9px 25px;\n}\n\n.footer_bottom_section_content {\n    color: #FFF;\n    justify-content: space-between;\n    letter-spacing: 0.25px;\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.footer_bottom_icon {\n    display: inline-block;\n}\n\n.slick-dots {\n    position: absolute;\n    display: block;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    text-align: center;\n    z-index: 1;\n}\n\n\n.search_input_home::-moz-placeholder, .search_input_home::placeholder {\n    color: #000;\n    letter-spacing: 0.5px;\n    font-family: acumin-pro, sans-serif;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.css-10gf8jm, .css-sntwt5 {\n    max-width: 100% !important;\n}\n\n.menu_item {\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n    padding-left: 0% !important;\n}\n\n.css-1ltezim:focus, .css-1ltezim[data-focus] {\n    z-index: 1;\n    box-shadow: none !important;\n    background-color: none !important;\n}\n\n.css-1ltezim:active, .css-1ltezim[data-active] {\n    background: none !important;\n}\n\n.main_menu_mt_home a {\n    letter-spacing: 1.25px;\n    text-transform: uppercase;\n    font-family: acumin-pro, sans-serif;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n}\n\n.chakra-menu__menuitem {\n    color: #000000;\n}\n\n.footer_menu_heading {\n    letter-spacing: 0.5px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: acumin-pro, sans-serif;\n}\n\n.menu_footer_mt {\n    font-family: acumin-pro, sans-serif;\n}\n\nul.footer_icons {\n    display: flex;\n    width: 100%;\n    max-width: 100%;\n    justify-content: flex-end;\n    position: relative;\n    z-index: 1;\n}\n\n.footer_icon {\n    width: 27% !important;\n    padding: 10px 0 !important;\n    margin-left: 0 !important;\n}\n\n.footer_headings {\n    font-weight: 300;\n}\n\n\n.slick-dots li button:before {\n    font-size: 20px !important;\n    opacity: 1 !important;\n    color: #FFFFFF !important;\n\n}\n\n.slick-dots li.slick-active button:before {\n    color: #EC7700 !important;\n}\n\n.left_contact {\n    width: 50%;\n    padding: 50px;\n}\n\n.right_contact {\n    width: 50%;\n    padding: 50px;\n    background-color: #F6F6F6;\n}\n\n.input_type {\n    background-color: white !important;\n}\n\n.form_controll {\n    padding: 10px;\n}\n\n.content_box {\n    width: 68%;\n    line-height: 24px;\n}\n\n.left_contact_child {\n    padding: 10px 0;\n}\n\n.download-broucher > td:first-child {\n    width: 100%;\n}\n\n@media (max-width: 900px) {\n\n    .header_respo {\n        width: 80%;\n        margin: auto;\n    }\n\n    .slideBox {\n        font-size: 30px !important;\n    }\n\n    .slick-next {\n        right: 30px !important;\n    }\n\n    .team .teammember {\n        width: 250px;\n        margin: 20px auto;\n        height: 250px;\n        border-radius: 50%;\n    }\n\n    .about_slider {\n        color: #FFFF;\n        top: 50px;\n        left: 20px;\n        width: 90% !important;\n        text-align: center;\n        padding: 0 25px;\n        margin: 0 10px;\n    }\n\n    .slider_box {\n        width: 100% !important;\n        padding: 15px 0;\n    }\n\n    .context_flex {\n        display: block;\n    }\n\n    .left_contact, .right_contact {\n        width: 100%;\n        padding: 10px;\n    }\n}\n\n\n.svg_icon_branch {\n    width: 25px;\n    height: 25px;\n    margin-right: 15px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.new_branch_tab {\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    display: flex;\n    align-items: center;\n}\n\n.company_page_container {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.drillcut_companies {\n    padding-left: 60px;\n}\n\n.drillcut_companies {\n    padding-left: 60px;\n    max-width: 1000px;\n}\n\n.drillcut_company_new_add {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 18px;\n}\n\n.drillcut_table_branch th {\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000;\n}\n\n.company_title_heading {\n    padding-left: 60px;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.company_title_heading .pages_project_bar_heading {\n    font-weight: 700;\n    font-size: 34px;\n    line-height: 36px;\n    color: #1A1A1A;\n    text-transform: capitalize;\n    text-align: left;\n}\n\n.mini_dark_grey_color {\n    background: #F6F6F6;\n}\n\n.branch_information_tab {\n    background: #E9EAEB;\n}\n\n.branchinformationheading {\n    padding: 15px;\n    letter-spacing: 0.15px;\n    text-transform: uppercase;\n    font-weight: 700 !important;\n    font-size: 14px !important;\n    line-height: 16px !important;\n    text-align: left;\n}\n\n.company_information_form {\n    padding: 15px;\n}\n\n.company_detail_form_grid {\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.company_detail_form_grid input, .company_detail_form_grid select {\n    background: #FFFFFF;\n    border-radius: 5px;\n}\n\n.labels_company_data {\n    letter-spacing: 0.15px;\n    text-transform: uppercase;\n    font-weight: 400 !important;\n    font-size: 12px !important;\n    line-height: 16px !important;\n}\n\n.branchLinkColor {\n    color: #F58220;\n    letter-spacing: 0.25px;\n    font-size: 14px;\n    line-height: 20px;\n    text-transform: capitalize;\n    font-weight: 600;\n}\n\n@media (max-width: 769px) {\n\n    .about_contain {\n        padding: 30px;\n    }\n\n    .company_title_heading {\n        padding: 20px !important;\n    }\n\n    .drillcut_companies {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .about_2_box {\n        width: 100%;\n    }\n\n    .flexDirection {\n        flex-direction: column;\n    }\n\n    .drillcut_company_mobile_view {\n        display: flex;\n        padding: 20px;\n        margin-bottom: 15px;\n    }\n\n    .branchInformationHeading {\n        margin-right: 35px;\n        text-align: left;\n    }\n\n    .branchInformationContent {\n        text-align: left;\n    }\n\n    .branchInformationContent a {\n        letter-spacing: 0.25px;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .orderBy {\n        order: 1;\n    }\n\n    .about_2_box img {\n        width: 100%;\n    }\n\n    .content_box {\n        width: 100%\n    }\n\n    .layer_box_icon {\n        width: 90%;\n        padding: 50px 0;\n    }\n\n    .about_contain {\n        padding: 50px !important;\n    }\n\n    .header_respo {\n        width: 100%;\n        padding: 10px 0;\n        font-size: 30px;\n    }\n\n    .about-box {\n        height: auto;\n        padding: 40px 50px;\n    }\n\n    .slideBox {\n        font-size: 20px !important;\n    }\n\n    .slick-next {\n        right: 10px !important;\n    }\n\n    .team .teammember {\n        width: 250;\n        margin: 20px auto;\n        height: 250;\n        border-radius: 50%;\n    }\n\n    .about_slider {\n        color: #FFFF;\n        top: 50px;\n        left: 15px;\n        width: 90% !important;\n        text-align: center;\n        padding: 0 25px;\n        margin: 0 10px;\n    }\n\n\n    .split_icon_desktop {\n        display: none;\n    }\n\n    .footer_bottom_section {\n        padding-top: 25px !important;\n        padding-bottom: 25px !important;\n    }\n\n    .footer_bottom_section_content, .footer_headings {\n        display: flex;\n        flex-direction: column;\n    }\n\n    p.footer_logo {\n        margin-top: 15px;\n    }\n\n    ul.footer_icons {\n        justify-content: flex-start;\n    }\n\n    .footer_menu-content {\n        justify-content: space-between;\n    }\n\n    .menu_icon_mobile_view {\n        justify-content: flex-end !important;\n    }\n\n    .menu_icon_mobile_view img {\n        width: 10px;\n    }\n}\n\n\n@media (max-width: 365px) {\n    .footer_logo_main {\n        width: 100%;\n    }\n\n    .footer_logo_main_logo {\n        width: 190px;\n    }\n\n    .footer_job_done_logo {\n        width: 75px;\n    }\n\n    .team .teammember {\n        width: 120px !important;\n        margin: 20px auto;\n        height: 120px !important;\n        border-radius: 50%;\n    }\n}\n\n\n@media (max-width: 515px) {\n\n    .layer_box_icon {\n        width: 100%;\n        padding: 50px 0;\n    }\n\n    .team .teammember {\n        width: 170px;\n        margin: 20px auto;\n        height: 170px;\n        border-radius: 50%;\n    }\n\n    .content_box {\n        width: 100%;\n    }\n\n    .about_container {\n        padding: 20px;\n    }\n\n    .about-box {\n        height: auto;\n        padding: 10px 0;\n    }\n\n    .about_contain {\n        padding: 0 !important;\n    }\n\n    .brands_image2 img {\n        width: 50%;\n        height: auto;\n    }\n\n    .about_main {\n        padding: 0;\n    }\n\n    .about_2_box {\n        width: 100%;\n    }\n\n    .slideBox {\n        font-size: 18px !important;\n    }\n\n    .slick-next {\n        right: 10px !important;\n    }\n\n    .about_slider {\n        color: #FFFF;\n        top: 50px;\n        left: 0;\n        width: 94% !important;\n        text-align: left;\n        padding: 0 25px;\n        margin: 0 10px;\n    }\n\n    .slider_box {\n        width: 100% !important;\n        padding: 15px 0;\n    }\n\n    .about_slider .slick-prev::before, .slick-next::before {\n        font-size: 35px;\n        color: #FFFFFF;\n        opacity: 1;\n    }\n\n    .header_respo {\n        padding: 10px 0;\n        font-size: 25px;\n    }\n\n}\n\n\n.full_width_container {\n    max-width: 100% !important;\n    padding: 0 !important;\n    position: relative !important;\n}\n\n.component {\n    padding-top: 20px;\n}\n\n.main_menu_items_mt {\n    font-family: acumin-pro, sans-serif;\n    font-weight: 700 !important;\n    letter-spacing: 1.25px;\n    line-height: 16px;\n    text-transform: uppercase;\n    color: #000;\n    font-size: 14px;\n}\n\n.main_menu_mt_home {\n    position: relative;\n}\n\n.truck_icon {\n    transform: scaleX(-1);\n    display: inline-block;\n    font-size: 20px;\n    vertical-align: bottom;\n}\n\n.menu_open_mt {\n    position: absolute;\n    width: 365px;\n    left: -10px;\n    top: 46px;\n    background-color: #F2F2F2 !important;\n    border: none;\n    border-radius: 0 !important;\n    z-index: 9 !important;\n}\n\n.Default_height_set {\n    overflow: hidden;\n    overflow-y: auto;\n    max-height: calc(95vh - 164px);\n    height: 88vh;\n    width: 100%;\n}\n\ndiv[data-popper-placement=\"bottom-start\"] {\n    z-index: 999;\n}\n\n.main_class_menu_mt {\n    background-color: white;\n}\n\n.activetag {\n    background-color: blue;\n}\n\n.chiled_open_mt {\n    position: absolute;\n    width: 365px;\n    left: 360px;\n    top: 0;\n    background-color: #F2F2F2 !important;\n    border: none;\n    border-radius: 0 !important;\n}\n\n.chiled_open_mt-2 {\n    position: absolute;\n    width: 365px;\n    left: 360px;\n    top: 0;\n    background-color: #F2F2F2 !important;\n    border: none;\n    border-radius: 0 !important;\n}\n\n.menu_open_mt button, .chiled_header, .dropdown_menu_list, .menu_open_mt > a {\n    padding: 20px 30px;\n    min-height: 58px;\n    border-bottom: 1px solid #C4C4C4;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    color: #000000;\n    z-index: 999;\n}\n\n.dropdown_menu_list {\n    display: flex;\n}\n\n.active, .menu_open_mt button:hover, .dropdown_menu_list:hover, .menu_open_mt > a:hover {\n    background-color: #592C82;\n    color: #FFF !important;\n}\n\n.log_vertical {\n    align-self: center !important;\n}\n\n.layer {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    left: 0;\n    height: 900px;\n    top: 55px;\n    z-index: 1;\n}\n\n.layer2 {\n    display: none;\n}\n\n.main_menu_mt_home .css-r6z5ec {\n    transform: none !important;\n}\n\n.main_menu_items_mt span {\n    display: flex;\n    justify-self: center;\n    align-items: center;\n}\n\n.button_mt_about {\n    width: 130px;\n    display: block;\n    text-align: center;\n    margin: 10px 0;\n}\n\n.slideBox {\n    line-height: 36px;\n    font-size: 34px;\n}\n\n.header_icons_mt .css-jfo9gg {\n    padding: 0 !important;\n}\n\n.drawer_menu_mt {\n    transform: translateX(0) translateY(70px) translateZ(0px) !important;\n    right: 2.67% !important;\n    width: 98% !important;\n    max-width: 98% !important;\n}\n\nli.list_items_menu_mobile {\n    list-style: none;\n    border-left: 10px solid #592C82;\n    padding: 25px 30px;\n    background: #F2F2F2;\n    border-bottom: 1px solid #C4C4C4;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n}\n\nul.mobile_menu_list {\n    margin: 0 !important;\n}\n\n.drawer_menu_mt .css-qwjbfp {\n    background: #F2F2F2 !important;\n}\n\n.drawer_body_content_mt {\n    padding: 0 !important;\n    background: #F2F2F2;\n}\n\n.list_button_menu_mobile {\n    list-style: none;\n    padding: 25px 30px;\n    background: #F2F2F2;\n    border-bottom: 1px solid #C4C4C4;\n    border-left: 10px solid transparent;\n}\n\n.drawermenu_close_button_mt {\n    position: relative !important;\n    width: 100% !important;\n    text-align: left;\n    justify-content: flex-start !important;\n    top: unset !important;\n    right: unset !important;\n    height: auto !important;\n}\n\n.drawermenu_close_button_mt_text {\n    font-family: acumin-pro, sans-serif;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    text-transform: uppercase;\n}\n\n.drawermenu_close_button_mt_text svg {\n    Width: 17px;\n    height: 18.55px;\n    color: #000000;\n    font-weight: 700;\n    margin-right: 7px;\n}\n\n.drawermenu_close_button_mt:focus, .drawermenu_close_button_mt[data-focus] {\n    box-shadow: none !important;\n}\n\n.drawermenu_close_button_mt:active, .drawermenu_close_button_mt[data-active] {\n    background: transparent !important;\n}\n\n.drawermenu_close_button_mt, .drawermenu_close_button_mt[data-hover] {\n    background: transparent !important;\n}\n\n.drawermenu_item_mt {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.drawermenu_item_mt svg {\n\n    Width: 17px;\n    height: 17px;\n    color: #000000;\n    font-weight: 700;\n}\n\nspan.main_menu_showdrawer_mt {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    color: #000000;\n}\n\n.an_testimonial_text_title_box {\n    max-height: 500px !important;\n}\n\n.an_comment_box {\n    height: auto !important;\n}\n\n.chat-now-button {\n    width: 120px;\n    height: 40px;\n    position: fixed;\n    bottom: 30px;\n    left: 30px;\n    z-index: 120;\n}\n\n.bg_strip_btn_save .chakra-text,\n.bd_crum .chakra-text {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: 1.25px;\n    text-transform: uppercase;\n    color: #EC7700;\n    cursor: pointer;\n    transition: all 0.3s ease-in;\n}\n\n.about_announcment_container.center {\n    text-align: center;\n}\n\nbody .chakra-container {\n    max-width: 100%;\n}\n\n.know-us-image-top {\n    display: none;\n}\n\n.root-certify .know-us-image-top.certify,\n.root-supply .know-us-image-top.supply,\n.root-customise .know-us-image-top.customise,\n.root-train .know-us-image-top.train,\n.root-plan .know-us-image-top.plan,\n.root-design .know-us-image-top.design,\n.root-consult .know-us-image-top.consult,\n.root-review .know-us-image-top.review,\n.root-360 .know-us-image-top[data-class=\"360\"] {\n    display: block;\n}\n\n.cone-aa .imgclick {\n    opacity: 0.2;\n}\n\n.root-certify .cone-aa .certify,\n.root-supply .cone-aa .supply,\n.root-customise .cone-aa .customise,\n.root-train .cone-aa .train,\n.root-plan .cone-aa .plan,\n.root-design .cone-aa .design,\n.root-consult .cone-aa .consult,\n.root-review .cone-aa .review,\n.root-360 .cone-aa .imgclick {\n    opacity: 1;\n}\n\n.tabs-menu .menuclick {\n    cursor: pointer;\n}\n\n.root-certify .tabs-menu .menuclick.certify,\n.root-supply .tabs-menu .menuclick.supply,\n.root-customise .tabs-menu .menuclick.customise,\n.root-train .tabs-menu .menuclick.train,\n.root-plan .tabs-menu .menuclick.plan,\n.root-design .tabs-menu .menuclick.design,\n.root-consult .tabs-menu .menuclick.consult,\n.root-review .tabs-menu .menuclick.review,\n.root-360 .tabs-menu .menuclick[data-class=\"360\"] {\n    background-color: #592C82 !important;\n}\n\n.root-certify .tabs-menu .menuclick.certify a,\n.root-supply .tabs-menu .menuclick.supply a,\n.root-customise .tabs-menu .menuclick.customise a,\n.root-train .tabs-menu .menuclick.train a,\n.root-plan .tabs-menu .menuclick.plan a,\n.root-design .tabs-menu .menuclick.design a,\n.root-consult .tabs-menu .menuclick.consult a,\n.root-review .tabs-menu .menuclick.review a,\n.root-360 .tabs-menu .menuclick[data-class=\"360\"] a {\n    color: #fff;\n}\n\n.level-2 td.blck-srtdt.css-xumdn4 spancustom::before,\n.level-1 td.blck-srtdt.css-xumdn4 spancustom::before {\n    content: '';\n    border-left: 2px solid #cccccc;\n    text-indent: 20px;\n    position: absolute;\n    height: 100%;\n    top: 0;\n}\n\n.level-2 td.blck-srtdt.css-xumdn4 spancustom::before {\n    margin-left: -46px;\n}\n\n.level-1 td.blck-srtdt.css-xumdn4 spancustom::before {\n    margin-left: -21px;\n}\n\ntr.level-1.css-4g6ai3,\ntr.level-2.css-4g6ai3 {\n    position: relative;\n}\n\n\n.level-2 td.blck-srtdt.css-xumdn4 spancustom::after {\n    content: '';\n    border-top: 2px solid #cccccc;\n    position: absolute;\n    width: 35px;\n    left: 63px;\n    top: 50%;\n}\n\n.level-1 td.blck-srtdt.css-xumdn4 spancustom::after {\n    content: '';\n    border-top: 2px solid #cccccc;\n    position: absolute;\n    width: 10px;\n    left: 63px;\n    top: 50%;\n}\n\n.background_image_loading {\n    background: url(\"./image/ProductPlaceholder.jpg\") no-repeat center center;\n    background-size: contain;\n}\n\n.flex-box {\n    display: flex;\n}\n\n.align-flex-center {\n    align-items: center;\n}\n\n.user-to-drop {\n    border: 1px solid #ec7700;\n}\n\n.text-uppercase {\n    text-transform: capitalize;\n}\n\n.chakra-popover__popper.css-1qq679y {\n    z-index: 1500 !important;\n}\n\n#content-box {\n    align-self: flex-start;\n}\n\n#brand-text {\n    padding-top: 20px !important;\n    height: 130px !important;\n}\n\n.hs-shadow-container.active {\n    background-color: transparent;\n}\n\n@media screen and ( max-width: 930px) {\n    #brand-text {\n        padding-top: 20px !important;\n        height: auto !important;\n    }\n}\n\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Blur effect */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n  }\n  \n  .loader {\n    width: 50px;\n    height: 50px;\n    border: 5px solid #553c9a;\n    border-top: 5px solid transparent;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
